import React from 'react';
import Route from './routes';
import './App.css';
import Loader from './components/common/Loader';
import ScrollToTop from './components/specific/ScrollToTop';

function App() {
  return (
    <>
      <ScrollToTop />
      <Loader />
      <Route />
    </>
  );
}

export default App;
